var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManuals = function SvgManuals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M15.837 19.75a4.002 4.002 0 0 0 4.235-3.993V6.755a4 4 0 0 0-3.765-3.993l-8.072-.475A4 4 0 0 0 4 6.28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M4 6.33C4 3.805 6.58 2.1 8.902 3.092l5.213 2.225a3 3 0 0 1 1.822 2.76V18.77c0 2.152-2.198 3.604-4.177 2.76l-5.938-2.535A3 3 0 0 1 4 16.236z"
  })));
};
export default SvgManuals;